import React from 'react';
import { DateTime } from 'luxon';
import styles from './maintenancePage.module.scss';

const MaintenancePage = ({ until }) => (
    <div className={styles.container}>
        <div className={styles.title}>
            🛠
            <br />
            We are under maintenance
        </div>
        <div className={styles.subtitle}>
            We are performing maintenance operations on our system. <br />
            Please be a little patient, the website should be back online by{' '}
            {DateTime.fromISO(until).toLocaleString(DateTime.TIME_24_SIMPLE)} !
        </div>
    </div>
);

export default MaintenancePage;
